import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import { NolimitApplication } from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import { Device } from "@nolimitcity/slot-launcher/bin/interfaces/APIOptions";
import { APISetting } from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import { gsap } from "gsap";

import { ScreenProperties } from "../types/interfaces";

export const sleep = (milliseconds: number) => {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
};

export const getRandomElement = (array: any) => {
    return array[Math.floor(Math.random() * array.length)];
};

export const getRandomBetween = (min: number, max: number, rounded: boolean = false) => {
    if (!rounded) return Math.random() * (max - min) + min;
    else return Math.round(Math.random() * (max - min) + min);
};

export const getTotalFromArrayByPropertyName = (array: any[], propertyName: string) =>
    array.reduce((a: any, b: any) => {
        return a + b[propertyName];
    }, 0);

export const getScreenProperties = (): ScreenProperties => {
    return {
        isLandscape: NolimitApplication.isLandscape,
        isPortrait: !NolimitApplication.isLandscape,
        isMobile: NolimitApplication.apiPlugin.options.device === Device.MOBILE,
        bounds: NolimitApplication.screenBounds,
    };
};

export const getDistance = (
    position1: { x: number; y: number },
    position2: { x: number; y: number }
): number => {
    return Math.round(
        Math.sqrt((position1.x - position2.x) ** 2 + (position1.y - position2.y) ** 2)
    );
};

export const addSkip = (tl: gsap.core.Timeline, controller: FlowStateController): void => {
    // ! poate ar trebui pus label aici?

    if (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
        tl.timeScale(2);
    }

    const skipLabel = `skipLabel`;
    tl.addLabel(skipLabel, tl.totalDuration() - 0.1);

    const skipToNextLevel = () => {
        const nextLabel: string = tl.nextLabel();

        tl.seek(tl.labels[nextLabel], false);
    };

    tl.addLabel(`skip`, `>-=0.1`);

    controller.setSkipCallback(skipToNextLevel);
};

export const generateFilledArray = (length: number, value: any): any[] => {
    const deepCopy = (val: any): any => {
        if (val instanceof Array) {
            return val.map(deepCopy); // Recursively copy each element if it's an array
        }
        return val; // Return the value directly if it's not an array
    };

    return new Array(length).fill(null).map(() => deepCopy(value));
};
